// import * as React from "react";
// const SvgCapitalW = React.forwardRef((props, svgRef) => {
//   return (
//     <svg
//       width={32}
//       height={32}
//       fill="none"
//       viewBox="0 0 32 32"
//       ref={svgRef}
//       {...props}
//     >
//       <path
//         fill="#717171"
//         d="M22.25 21.84a2.252 2.252 0 01-.36.74 1.905 1.905 0 01-.42.44c-.147.093-.3.153-.46.18-.147.04-.28.06-.4.06s-.253-.02-.4-.06a1.233 1.233 0 01-.44-.18 2.284 2.284 0 01-.44-.44 2.558 2.558 0 01-.34-.74l-2.98-9.3h-.04l-2.98 9.3a2.939 2.939 0 01-.36.74 1.905 1.905 0 01-.42.44c-.147.093-.3.153-.46.18-.147.04-.28.06-.4.06s-.253-.02-.4-.06a1.43 1.43 0 01-.46-.18 1.909 1.909 0 01-.42-.44 2.556 2.556 0 01-.34-.74l-3.36-11.2a2.797 2.797 0 01-.08-.38c-.013-.107-.02-.2-.02-.28 0-.36.127-.653.38-.88.253-.24.553-.36.9-.36.227 0 .467.073.72.22.253.147.453.473.6.98l2.62 9.38h.04l2.84-9.02c.107-.347.227-.62.36-.82a1.96 1.96 0 01.44-.48 1.08 1.08 0 01.44-.2c.147-.04.287-.06.42-.06s.273.02.42.06c.147.027.293.093.44.2.147.107.287.267.42.48.147.2.273.473.38.82l2.78 9.02h.04l2.68-9.42c.147-.493.34-.807.58-.94.253-.147.493-.22.72-.22.333 0 .62.113.86.34.253.213.38.513.38.9 0 .08-.007.167-.02.26 0 .093-.02.2-.06.32l-3.4 11.28z"
//       />
//     </svg>
//   );
// });
// const MemoForwardRef = React.memo(SvgCapitalW);
// export default MemoForwardRef;

import React, { memo, forwardRef } from "react";
const SvgCapitalW = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M22.25 21.84a2.252 2.252 0 01-.36.74 1.905 1.905 0 01-.42.44c-.147.093-.3.153-.46.18-.147.04-.28.06-.4.06s-.253-.02-.4-.06a1.233 1.233 0 01-.44-.18 2.284 2.284 0 01-.44-.44 2.558 2.558 0 01-.34-.74l-2.98-9.3h-.04l-2.98 9.3a2.939 2.939 0 01-.36.74 1.905 1.905 0 01-.42.44c-.147.093-.3.153-.46.18-.147.04-.28.06-.4.06s-.253-.02-.4-.06a1.43 1.43 0 01-.46-.18 1.909 1.909 0 01-.42-.44 2.556 2.556 0 01-.34-.74l-3.36-11.2a2.797 2.797 0 01-.08-.38c-.013-.107-.02-.2-.02-.28 0-.36.127-.653.38-.88.253-.24.553-.36.9-.36.227 0 .467.073.72.22.253.147.453.473.6.98l2.62 9.38h.04l2.84-9.02c.107-.347.227-.62.36-.82a1.96 1.96 0 01.44-.48 1.08 1.08 0 01.44-.2c.147-.04.287-.06.42-.06s.273.02.42.06c.147.027.293.093.44.2.147.107.287.267.42.48.147.2.273.473.38.82l2.78 9.02h.04l2.68-9.42c.147-.493.34-.807.58-.94.253-.147.493-.22.72-.22.333 0 .62.113.86.34.253.213.38.513.38.9 0 .08-.007.167-.02.26 0 .093-.02.2-.06.32l-3.4 11.28z"
      />
    </svg>
  );
});
SvgCapitalW.displayName = "SvgCapitalW";
const MemoForwardRef = memo(SvgCapitalW);
export default MemoForwardRef;
